import { t } from "@lingui/macro";

import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import {
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

export const DurationControlSkeleton = () => {
  return (
    <VStack
      gap={4}
      padding={5}
      paddingBottom={3}
      width="100%"
      backgroundColor="surface-primary"
    >
      <Text variant="mainBaseSemiBold">{t`Duration`}</Text>
      <HStack gap={2} width="100%">
        <SkeletonLoader flex={1} height={48} borderRadius="2" />
        <SkeletonLoader flex={1} height={48} borderRadius="2" />
        <SkeletonLoader flex={1} height={48} borderRadius="2" />
      </HStack>
    </VStack>
  );
};
